var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavingChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#EEF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 27.75C34 27.5511 33.921 27.3603 33.7803 27.2197C33.6397 27.079 33.4489 27 33.25 27H30.25C30.0511 27 29.8603 27.079 29.7197 27.2197C29.579 27.3603 29.5 27.5511 29.5 27.75V34.5H28V18.25C28 17.522 27.998 17.05 27.952 16.704C27.908 16.379 27.837 16.277 27.78 16.22C27.723 16.163 27.621 16.092 27.296 16.048C26.949 16.002 26.478 16 25.75 16C25.022 16 24.55 16.002 24.204 16.048C23.879 16.092 23.777 16.163 23.72 16.22C23.663 16.277 23.592 16.379 23.548 16.704C23.502 17.051 23.5 17.522 23.5 18.25V34.5H22V22.75C22 22.5511 21.921 22.3603 21.7803 22.2197C21.6397 22.079 21.4489 22 21.25 22H18.25C18.0511 22 17.8603 22.079 17.7197 22.2197C17.579 22.3603 17.5 22.5511 17.5 22.75V34.5H15.75C15.5511 34.5 15.3603 34.579 15.2197 34.7197C15.079 34.8603 15 35.0511 15 35.25C15 35.4489 15.079 35.6397 15.2197 35.7803C15.3603 35.921 15.5511 36 15.75 36H35.75C35.9489 36 36.1397 35.921 36.2803 35.7803C36.421 35.6397 36.5 35.4489 36.5 35.25C36.5 35.0511 36.421 34.8603 36.2803 34.7197C36.1397 34.579 35.9489 34.5 35.75 34.5H34V27.75Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingChartIcon);
export default __webpack_public_path__ + "static/media/saving-chart-icon.6811c48cf6745fb79077da2a749d5f72.svg";
export { ForwardRef as ReactComponent };